export function isBlank(str: string | undefined): boolean {
  return !str || /^\s*$/.test(str);
}

export function isNotBlank(str: string | undefined): str is string {
  return !isBlank(str);
}
